import { Button } from '@vds/components';

import {
    DEFAULT_DEV_ERROR_MESSAGE,
    dispatchDevThrowErrorBoundary,
} from '@/utils/devtools/error-boundary-dev-tool';

import styles from './SwitchTool.module.css';

export default function ErrorBoundaryDevTool() {
    return (
        <div className={styles.infoContainer}>
            <h3>Error Boundary</h3>
            <p>Throws a test error inside the error boundary to verify the fallback UI.</p>
            <div className={styles.buttonContainer}>
                <Button
                    colorScheme="primary"
                    onClick={() =>
                        dispatchDevThrowErrorBoundary({ message: DEFAULT_DEV_ERROR_MESSAGE })
                    }>
                    Throw Error
                </Button>
            </div>
        </div>
    );
}
